/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-27 14:00:36
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-10-26 14:43:07
 */
import common from "./common";
import config from "../config/config";
import Vue from "vue";
import i18n from "@/config/i18n";
export const time = (value, type) => {
    if (value) {
        if (typeof value === "number") {
            const typeStr = type || "yyyy-mm-dd hh:mm:ss";
            return common.userDate(value, typeStr);
        }
        else {
            return value;
        }
    }
    else {
        return "";
    }
};
export const Fixed = (value, type) => {
    if (typeof value === "number" && !isNaN(value)) {
        const m = type && type >= 0 ? type : 2;
        // return value.toFixed(n);
        const resultNum = Math.round(Math.pow(10, m) * value) / Math.pow(10, m);
        let result = String(resultNum);
        if (result.indexOf(".") == -1) {
            if (m != 0) {
                result += ".";
                result += new Array(m + 1).join("0");
            }
        }
        else {
            const arr = result.split(".");
            if (arr[1].length < m) {
                arr[1] += new Array(m - arr[1].length + 1).join("0");
            }
            result = arr.join(".");
        }
        return result;
    }
    else {
        return 0;
    }
};
export const percentage = (value) => {
    if (value > 0) {
        return value + "%";
    }
    else {
        return "-";
    }
};
export const percentageValue = (value, num) => {
    if (typeof value == "number") {
        num = 2 || num;
        value = parseFloat((value * 100).toFixed(num));
        return value + "%";
    }
    else {
        return "-";
    }
};
export const fileUrl = (value) => {
    if (value && value.indexOf("http") == 0) {
        return value;
    }
    else if (value && typeof value !== "undefined") {
        return config.fileImg + value;
    }
    return "";
};
export const localUrl = (value) => {
    if (value && value.indexOf("http") == 0) {
        return value;
    }
    else if (value && typeof value !== "undefined") {
        return config.host + value;
    }
    return "";
};
export const defaultText = (value) => {
    if (value || value === 0) {
        return value + "";
    }
    else {
        return "--";
    }
};
export const defaultNumber = (value) => {
    if (value || value == 0) {
        return value;
    }
    else {
        return 0;
    }
};
export const bankCard = (value) => {
    if (value) {
        if (typeof value == "number") {
            value = value + "";
        }
        return value.replace(/\s/g, "").replace(/(.{4})/g, "$1 ");
    }
    else {
        return "";
    }
};
export const discount = (value) => {
    if (value || value == 0) {
        if (value >= 1) {
            const value2 = i18n.locale == "en-US" ? "100%" : i18n.t("unitText.noDiscount") + "";
            return value2;
        }
        else {
            const text1 = parseFloat((value * 100).toFixed(2));
            const text2 = parseFloat((value * 10).toFixed(2));
            const value2 = i18n.locale == "en-US" ? text1 + "%" : text2 + "折";
            return value2;
        }
    }
    else {
        return "--";
    }
};
export const formatMinute = (value, type) => {
    // 默认是分钟, type  m  是秒
    if (type === "m") {
        if (value > 60) {
            let hour;
            let minute = Math.trunc(value / 60);
            const second = Math.trunc(value % 60);
            if (minute > 60) {
                hour = Math.trunc(minute / 60);
                minute = Math.trunc(minute % 60);
                return (hour +
                    "" +
                    i18n.t("unitText.xHours") +
                    minute +
                    i18n.t("unitText.minute") +
                    second +
                    i18n.t("unitText.seconds"));
            }
            else {
                return (minute +
                    "" +
                    i18n.t("unitText.minute") +
                    second +
                    i18n.t("unitText.seconds"));
            }
        }
        else {
            return value + "" + i18n.t("unitText.seconds");
        }
    }
    else if (type === "minute") {
        const minute = Math.trunc(value / 60);
        return minute + "" + i18n.t("unitText.minute");
    }
    else {
        if (value > 60) {
            const hour = Math.trunc(value / 60);
            const minute = Math.trunc(value % 60);
            return (hour +
                "" +
                i18n.t("unitText.xHours") +
                minute +
                i18n.t("unitText.minute"));
        }
        else if (value > 0) {
            return Math.trunc(value) + "" + i18n.t("unitText.minute");
        }
        else {
            return "0" + i18n.t("unitText.minute");
        }
    }
};
export const invoiceFileUrl = (value) => {
    if (value !== "" &&
        value.indexOf("http://") == -1 &&
        value !== "" &&
        value.indexOf("https://") == -1) {
        return "https://" + value;
    }
    else {
        return value;
    }
};
export const numberMax = (value, isUnit) => {
    const val = value || 0;
    isUnit = isUnit != undefined ? isUnit : true;
    const unitText = isUnit ? i18n.t("unitText.wan") + "" : "";
    const text = val > 10000 ? (val / 10000).toFixed(2) + unitText : val;
    return text;
};
export const power = (value) => {
    if (value >= 0 && value > 1000) {
        return parseFloat((value / 1000).toFixed(2));
    }
    else {
        return value;
    }
};
Vue.filter("time", time);
Vue.filter("toFixed", Fixed);
Vue.filter("fileUrl", fileUrl);
Vue.filter("defaultText", defaultText);
Vue.filter("bankCard", bankCard);
Vue.filter("percentage", percentage);
Vue.filter("percentageValue", percentageValue);
Vue.filter("discount", discount);
Vue.filter("defaultNumber", defaultNumber);
Vue.filter("formatMinute", formatMinute);
Vue.filter("invoiceFileUrl", invoiceFileUrl);
Vue.filter("numberMax", numberMax);
Vue.filter("localUrl", localUrl);
Vue.filter("power", power);
